export const SET_USER_BRANCH_DETAIL = 'SET_USER_BRANCH_DETAIL';
export const GET_COUNTRY_DROPDOWN = 'GET_COUNTRY_DROPDOWN';
export const SET_COUNTRY_DROPDOWN = 'SET_COUNTRY_DROPDOWN';
export const SET_BRANCH_VALUES = 'SET_BRANCH_VALUES';
export const GET_BRANCH_VALUES = 'GET_BRANCH_VALUES';
export const SET_RESULT_MESSAGE = 'SET_RESULT_MESSAGE';
export const GET_USER_DETAIL = 'GET_USER_DETAIL';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const SHOW_USER_PROFILE = 'SHOW_USER_PROFILE';
export const SET_COUNTRY_DETAILS =  'SET_COUNTRY_DETAILS';
export const GET_USER_DETAIL_EXTERNAL = 'GET_USER_DETAIL_EXTERNAL';
export const SET_USER_DETAIL_EXTERNAL = 'SET_USER_DETAIL_EXTERNAL';
export const SET_BRANCH = "SET_BRANCH";